

export const ageOptions = [
  { key: 'teen', value: 'teen', text: 'Teen (13-19)' },
  { key: 'young-adults', value: 'young-adult', text: 'Young Adults (20-35)' },
  { key: 'adults', value: 'adult', text: 'Adults (36-55)' },
  { key: 'seniors', value: 'senior', text: 'Seniors (55+)' },
];

export const genderOptions = [
  { key: 'male', value: 'male', text: 'Male' },
  { key: 'female', value: 'female', text: 'Female' },
  { key: 'non-binary', value: 'non-binary', text: 'Non-binary' },
  { key: 'genderfluid', value: 'genderfluid', text: 'Gender fluid' },
  { key: 'transgender', value: 'transgender', text: 'Transgender' },
];

export const ethnicityOptions = [
  { key: 'black', value: 'black-caribbean-african', text: 'Black, Caribbean, African' },
  { key: 'asian', value: 'asian', text: 'Asian' },
  { key: 'hispanic', value: 'hispanic-latino', text: 'Hispanic/Latino' },
  { key: 'white', value: 'white-caucasian', text: 'White/Caucasian' },
  { key: 'mixed', value: 'mixed-multiracial', text: 'Mixed/Multiracial' },
];




/** WEBPACK FOOTER **
 ** ./src/components/influencer-form/influencer-form-options.js
 **/